import React from 'react';
import StyledTextField from './styled-text-field';

interface IFreeTextFieldProps {
  value: string;
  handleChange: (value: string) => void;
  handleBlur: (value: React.FocusEvent) => void;
  label: string;
  // eslint-disable-next-line react/require-default-props
  error?: string;
  // eslint-disable-next-line react/require-default-props
  isDisabled?: boolean;
}

export default function FreeTextFieldControl({
  handleChange,
  handleBlur,
  label,
  value,
  isDisabled = false,
  error = ''
}: IFreeTextFieldProps) {
  return (
    <StyledTextField
      id={label}
      type='text'
      disabled={isDisabled}
      size='small'
      error={!!error}
      helperText={error || ''}
      fullWidth
      variant='outlined'
      value={value}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={(e) => handleBlur(e)}
    />
  );
}
